export interface IGallery {
  id?: number;
  tieuDe?: string | null;
  thuTu?: number | null;
}

export const defaultValue: Readonly<IGallery> = {};
